export default {
  computed: {
    $typeAheadRolesData() {
      return [
        { value: null, text: "optional" },
        { value: "mom", text: "Mom" },
        { value: "dad", text: "Dad" },
        { value: "sister", text: "Siste" },
        { value: "brother", text: "Brother" },
        { value: "daughter", text: "Daughter" },
        { value: "son", text: "Son" },
        { value: "aunt", text: "Aunt" },
        { value: "uncle", text: "Uncle" },
        { value: "brotherinlaw", text: "Brother In-Law" },
        { value: "sisterinlaw", text: "Sister In-Law" },
        { value: "stepmom", text: "Step Mom" },
        { value: "stepdad", text: "Step Dad" },
        { value: "churchmember", text: "Church Member" },
        { value: "pastor", text: "Paster" },
        { value: "babymama", text: "Baby Mama" },
        { value: "babydaddy", text: "Baby Daddy" },
        ...this.$store.getters["user/listRoles"]
      ];
    }
  }
};
